import { WSFilter } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { usePayerEngagementFilterOptions } from "../../../../Payers/hooks/usePayerEngagementFilterOptions";
import { usePayerFilterOptions } from "../../../../Payers/hooks/usePayerFilterOptions";

export function useBuildConfig() {
  const payerOptions = usePayerFilterOptions({
    filter: {
      "engagements.isWorkLoggingEnabled": true
    }
  });

  const assignmentOptions = usePayerEngagementFilterOptions({
    filter: {
      "engagements.isWorkLoggingEnabled": true
    }
  });

  return useMemo((): WSFilter[] => {
    const config: WSFilter[] = [];

    config.push({
      title: "Client",
      name: "payerId",
      type: "select",
      apiOptions: payerOptions
    });

    config.push({
      title: "Assignment",
      name: "assignmentId",
      type: "select",
      apiOptions: assignmentOptions
    });

    config.push({
      title: "Date range",
      name: "dateRange",
      type: "daterange",
      titleInLabel: true,
      options: ["all", "pastWeek", "pastMonth", "yearToDate", "custom"]
    });

    return config;
  }, [payerOptions, assignmentOptions]);
}
